export default __webpack_public_path__ + "static/media/link-arrow.1c9cc771.svg";